import {ChangeDetectorRef, Directive, OnInit, Optional, Self} from "@angular/core";
import {NgControl} from "@angular/forms";
import {IControlWithErrors} from "../components/public_components";

@Directive({
  selector: "n-input,n-textarea,n-time-picker,n-select"
})
export class NErrorsDirective implements OnInit {

  constructor(@Optional() @Self() private control: NgControl, private cd: ChangeDetectorRef) {

  }

  ngOnInit(): void {
    if (this.control) {
      const va = (this.control.valueAccessor as any) as IControlWithErrors;
      if (va.setErrors) {
        va.setErrors(this.control.errors);
        this.control.statusChanges.subscribe((a) => {
          va.setErrors(this.control.errors);
          this.cd.markForCheck();
        });
      }
    }
  }

}
